import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './SubsidiaryInformationComponent.module.scss';
import metadata from './SubsidiaryInformationComponent.metadata.json5';

function SubsidiaryInformationComponent(props) {

    const {
        data: SubsidiaryInformationVM,
        updateWizardData,
        submissionVM,
        SubsidiaryInformationPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addSubsidiaryInformation = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            SubsidiaryInformationVM.value = SubsidiaryInformationVM.value || []

            const { _xCenter, _dtoName } = SubsidiaryInformationVM;

            const SubsidiaryInformationObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            SubsidiaryInformationVM.pushElement(
                SubsidiaryInformationObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, SubsidiaryInformationVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            SubsidiaryInformationVM.value.splice(index, 1);
            _.set(submissionVM.value, SubsidiaryInformationPath, SubsidiaryInformationVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, SubsidiaryInformationPath, SubsidiaryInformationVM.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'nam1') {
                const value = item.nam1 ? item.nam1 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.nam1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'relToPriNamIns2') {
                const value = item.relToPriNamIns2 ? item.relToPriNamIns2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.relToPriNamIns2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'desOfOpe3') {
                const value = item.desOfOpe3 ? item.desOfOpe3 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.desOfOpe3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange, SubsidiaryInformationVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`SubsidiaryInformationTable`]: {
            data: SubsidiaryInformationVM.value,
        }

    }), [SubsidiaryInformationVM.value])

    const resolvers = {
        resolveCallbackMap: {
            addSubsidiaryInformation,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            SubsidiaryInformationVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [SubsidiaryInformationVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={SubsidiaryInformationVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

SubsidiaryInformationComponent.propTypes = wizardProps;
export default withRouter(SubsidiaryInformationComponent);
